import styled from 'styled-components';

const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  background-color: #fff;
  //padding: 120px 0px;
`;

const Inner = styled.div`
  width: 100%;
  padding: 40px 16px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 40px;
  background-color: #fff;
`;

const Title = styled.div`
  color: #171e26;
  font-size: 24px;
  font-family: Spoqa Han Sans Neo;
  font-weight: 700;
  line-height: 46.4px;
  word-wrap: break-word;
`;

const HistoryBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 40px;
  background-color: #fff;
`;

const YearWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  color: #171e26;
  font-size: 18px;
  font-family: Pretendard;
  font-weight: 700;
`;
const MonthContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 40px;
`;

const MonthWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  gap: 40px;

  color: #616161;
  font-size: 18px;
  font-family: 'Spoqa Han Sans Neo';
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 145%; /* 26.1px */
  letter-spacing: -0.36px;
`;
const MonthBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;
const Content = styled.div`
  display: flex;
  flex-direction: row;
  color: #616161;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 150%; /* 24px */
  letter-spacing: -0.32px;
  align-items: center;
  img {
    cursor: pointer;
    width: 24px;
    height: 24px;
  }
`;

export const S = {
  MonthContainer,
  Content,
  MonthBox,
  MonthWrapper,
  Container,
  Inner,
  Title,
  HistoryBox,
  YearWrapper,
};
